import ee, { STORAGE_KEYS as s } from "../managers/storage-manager.js";
export function isDisabled() {
  return !!new ee.ne(null, !0).br(s.ie);
}